import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs/operators';
import { ApiService } from 'src/app/_services/api-service';
import { TokenService } from 'src/app/_services/token.service';
import { User } from 'src/app/models';
import { environment } from 'src/environments/environment';
import { DadosLoginService } from './dados-login.service';

@Injectable({
    providedIn: 'root',
})
export class AuthApiService {
    private url = environment.apiUrl;
    private jwtHelper = new JwtHelperService();

    constructor(
        private http: HttpClient,
        private tokenService: TokenService,
        private dadosLoginService: DadosLoginService,
        private apiService: ApiService,
        private toastrService: ToastrService,
        private router: Router
    ) {}

    login(user: User) {
        return this.http.post<any>(`${this.url}api-token-auth/`, user).pipe(
            tap(res => {
                if (res.token) {
                    const expiration = this.jwtHelper
                        .getTokenExpirationDate(res.token)
                        .getTime();
                    this.tokenService.store(res.token, expiration);
                    this.dadosLoginService.reload();
                }
            })
        );
    }

    async logout() {
        if (this.tokenService.token) {
            this.http
                .post(`${this.url}api-token-auth/logout/`, {
                    token: this.tokenService.token,
                })
                .subscribe();
        }

        this.tokenService.clear();
        this.apiService.clearCurrent();
        this.dadosLoginService.clearAllData();

        await this.router.navigate(['/login'], { replaceUrl: true });
    }

    refresh_token() {
        return this.http
            .post<any>(`${this.url}refresh-token/`, {
                token: this.tokenService.token,
            })
            .pipe(
                tap(res => {
                    if (res.token) {
                        const expiration = this.jwtHelper
                            .getTokenExpirationDate(res.token)
                            .getTime();
                        this.tokenService.store(res.token, expiration);
                        this.dadosLoginService.reload();
                    }
                })
            );
    }

    esqueceuSenha(cpf: string) {
        const formData = new FormData();
        formData.append('cpf', cpf);
        return this.http.post(
            `${this.url}colaboradores/esqueci_senha/`,
            formData
        );
    }

    updatePassword(user) {
        const id_user = this.dadosLoginService.dados_login?.dados.id_user;
        if (!id_user) {
            throw new Error('User ID not found');
        }
        return this.http
            .put(`${this.url}usercrud/${id_user}/`, user)
            .pipe(tap(() => this.toastrService.success('Senha atualizada')));
    }

    check() {
        return this.http.post(`${this.url}check`, {});
    }
}
